import { Component, OnInit } from '@angular/core';
import { AdministrationService } from 'src/app/services/administration/administration.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video-galary',
  templateUrl: './video-galary.component.html',
  styleUrls: ['./video-galary.component.css']
})
export class VideoGalaryComponent implements OnInit {

  Submitted:boolean=false;
  VideoGalaryList:any;

   constructor(private adminservice: AdministrationService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,
    private _sanitizer: DomSanitizer) { }

    VideoGalaryModel = {
      VideoGalaryID: 0,
      Title: '',
      Description: '',
      URL: '',           
      IsActive: true
  };

  Clear() {
      this.VideoGalaryModel.VideoGalaryID = 0;
      this.VideoGalaryModel.Title = '';
      this.VideoGalaryModel.Description = '';
      this.VideoGalaryModel.URL = '';           
      this.VideoGalaryModel.IsActive = true;
      this.Submitted = false;
  };

  
  SaveVideoGalary(valid) {
    
      this.Submitted = true;
      if (valid) {
        this.spinnerService.show();
          this.adminservice.SaveVideoGalary(JSON.stringify(this.VideoGalaryModel)).subscribe((data: any) => {
            this.spinnerService.hide();
              this.Clear();
              this.GetAllVideoGalary();
              this.globalHelper.CheckActionStatus(data);   
          });
      }
  }

  embedURL(url){
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
    // return this.embedservice.embed_youtube(url);
  }
  

  GetAllVideoGalary() {
    this.spinnerService.show();
      this.adminservice.GetAllVideoGalary().subscribe((data: any) => {
          this.VideoGalaryList = data.VideoGalaryList;   
          if (this.VideoGalaryList != null) {
            for (var i = 0; i < this.VideoGalaryList.length; i++) {
              this.VideoGalaryList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.VideoGalaryList[i].YouTubeUrls);
    
            }
    
          }      
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(data);
      });
  };

  Edit(obj) {
      this.VideoGalaryModel.VideoGalaryID = obj.VideoGalaryID;
      this.VideoGalaryModel.Title = obj.Title;
      this.VideoGalaryModel.Description = obj.Description;          
      this.VideoGalaryModel.URL = obj.URL;           
      this.VideoGalaryModel.IsActive = obj.IsActive;
  };

  ngOnInit() {
    this.GetAllVideoGalary();
  }
  DeleteVideo(obj) {
    
    this.Submitted = true;
    this.VideoGalaryModel.VideoGalaryID = obj.VideoGalaryID;
      this.spinnerService.show();
        this.adminservice.DeleteVideo(JSON.stringify(this.VideoGalaryModel)).subscribe((data: any) => {
          this.spinnerService.hide();
            this.Clear();
            this.GetAllVideoGalary();
            this.globalHelper.CheckActionStatus(data);   
        });
    
}
}

